import { render, staticRenderFns } from "./search-people.vue?vue&type=template&id=f44009be&"
import script from "./search-people.vue?vue&type=script&lang=js&"
export * from "./search-people.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports